import { useMutation } from "@tanstack/react-query";
import { useRefreshAlgoliaData } from "entities/algolia/hooks/useRefreshAlgoliaData";
import { updateThemeTag } from "../api/updateThemeTag";
import { UpdateThemeTag } from "../types";
import { invalidateThemeTagDetailsQuery } from "./useThemeTagDetailsQuery";

type Params = {
  themeTagId: string;
  themeTag: UpdateThemeTag;
};

const INITIAL_DELAY_MS = 2000;
const REFRESH_INTERVAL_MS = 5000;

export const useUpdateThemeTagMutation = () => {
  const { refreshAlgoliaData } = useRefreshAlgoliaData();

  return useMutation({
    mutationFn: async ({ themeTag, themeTagId }: Params) => {
      const themeTagData = {
        ...themeTag,
        updatedAt: new Date(),
      };

      return await updateThemeTag(themeTagId, themeTagData);
    },
    onSuccess: (_, variables) => {
      // Invalidate query and refetch Algolia
      invalidateThemeTagDetailsQuery(String(variables.themeTagId));
      refreshAlgoliaData(INITIAL_DELAY_MS);
      refreshAlgoliaData(REFRESH_INTERVAL_MS);
    },
    onError: (e) => console.error(e),
  });
};
